var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"filter-tit"},[_vm._v("\n    "+_vm._s(_vm.fieldname)+"\n  ")]),_c('cube-input',{attrs:{"placeholder":`${_vm.enterPlaceholder} ${_vm.fieldname}`},on:{"change":_vm.handleChange},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }